import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageUpload from "../components/ImageUpload";
import { useDispatch, useSelector } from "react-redux";
import { validateReceipt } from "../redux/slices/receiptsSlice";
import AlertDialogComponent from "../components/AlertDialogComponent";
import BarcodeScannerPlugin from "../components/BarcodeScannerPlugin";
import { useNavigate } from "react-router";

const QrCodeScannerPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showUploadFieldView, setShowUploadFieldView] = useState(false);
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const [countClicks, setCountClicks] = useState(0);
  const [testLink, setTestLink] = useState("");
  const [showTestLink, setShowTestLink] = useState(false);
  const [showSuccessReadQRAlert, setShowSuccessReadQRAlert] = useState(false);
  const [continueScan, setContinueScan] = useState(false);
  const [QRReadError, setQRReadError] = useState();
  const [openEndGameDialog, setOpenEndGameDialog] = useState(true);
  const validateReceiptResult = useSelector(
    (state) => state.receipts.validateReceiptResult
  );

  const onSuccessReadResult = (link) => {
    setQRReadError("");
    dispatch(validateReceipt({ url: link })).then(
      (response) => {
        // console.log("response", response);
        setShowSuccessReadQRAlert(true);
      },
      (error) => {
        // console.log("error", error);
        alert("ERROR" + error);
      }
    );
  };
  useEffect(() => {
    setTimeout(() => {
      setShowInfoMessage(true);
    }, 6000);
  }, []);
  useEffect(() => {
    setQRReadError("");
    if (validateReceiptResult) {
      if (
        validateReceiptResult === "invalid_url" ||
        validateReceiptResult === "already_validated" ||
        validateReceiptResult === "store_not_in_promotion"
      ) {
        setQRReadError(t("errors." + validateReceiptResult));
      }
    }
  }, [validateReceiptResult, t]);

  const showUploadView = () => {
    setTimeout(() => {
      setShowInfoMessage(false);
      setShowUploadFieldView(true);
    }, 500);
  };
  const handleOnChangeTestLink = (event) => {
    setTestLink(event.target.value);
  };
  const sendDummyLink = () => {
    dispatch(validateReceipt({ url: testLink })).then(
      (response) => {},
      (error) => {
        console.log("error", error);
      }
    );
  };
  const handleGoBack = () => {
    setShowInfoMessage(true);
    setShowUploadFieldView(false);
  };
  const onCountClicks = () => {
    let clicks = countClicks + 1;
    setCountClicks(clicks);
  };
  const onCloseSuccessReadQRCode = () => {
    setShowSuccessReadQRAlert(false);
    setContinueScan(true);
    setTimeout(() => {
      setContinueScan(false);
    }, 500);
  };
  useEffect(() => {
    if (countClicks >= 5) {
      setShowTestLink(true);
      setCountClicks(0);
    }
  }, [countClicks]);
  const onCloseLastDayAlertDialog = () => {
    setOpenEndGameDialog(false);
  };
  const goBackToGifts = () => {
    navigate("/home/gift-page")
  }
  return (
    <Box paddingTop={2}>
      {openEndGameDialog ? (
        <Dialog
          open={openEndGameDialog}
          onClose={onCloseLastDayAlertDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description1"
        >
          <DialogTitle textAlign="center" id="alert-dialog-title">
            {t("endGame.title")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description3">
              <Typography color="black" variant="subtitle-1">
                {t("endGame.content")}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <Stack sx={{textAlign: "center"}} marginBottom={2} justifyContent="center" width="100%">
            <Button onClick={goBackToGifts}>
              {t("endGame.backToGifts")}
            </Button>
          </Stack>
        </Dialog>
      ) : (
        <>
          {showUploadFieldView ? (
            <Grid direction="column">
              <ImageUpload goBack={handleGoBack} />
            </Grid>
          ) : (
            <BarcodeScannerPlugin
              continueScan={continueScan}
              onSuccessReadResult={onSuccessReadResult}
            />
          )}

          {showInfoMessage && (
            <Alert
              onClick={onCountClicks}
              sx={{ display: "flex", alignItems: "center" }}
              severity="info"
              action={
                <Button color="inherit" size="small" onClick={showUploadView}>
                  {t("qrCodeScanner.send")}
                </Button>
              }
            >
              {t("qrCodeScanner.uploadImageInfoText")}
            </Alert>
          )}

          {showTestLink && (
            <Stack direction="column">
              <TextField
                id="testLink"
                label="Test link"
                value={testLink}
                onChange={handleOnChangeTestLink}
                fullWidth
                required
              />
              <Button
                disabled={!testLink}
                variant="contained"
                color="info"
                type="submit"
                fullWidth
                onClick={sendDummyLink}
              >
                {t("login.send")}
              </Button>
            </Stack>
          )}
          {showSuccessReadQRAlert && (
            <AlertDialogComponent
              open={showSuccessReadQRAlert}
              onClose={onCloseSuccessReadQRCode}
              onConfirm={onCloseSuccessReadQRCode}
              title={
                QRReadError
                  ? t("errors.qrCodeIsNotRead")
                  : t("qrCodeScanner.successReading")
              }
              text={QRReadError || t("qrCodeScanner.successReadingContent")}
              hideCancelBtn
            />
          )}
        </>
      )}
    </Box>
  );
};
export default QrCodeScannerPage;
